<template>
  <div>
    <p>This site is a work in progress.</p>

    <p>As such, I'll be working on design and functionality throughout the process of making the comic.</p>

    <p>Known Issues</p>
    <ul>
      <li>No way to mark comments as spam or report them (for now, just email erty)</li>
      <li>I want to eventually allow users to login with Facebook</li>
    </ul>

  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ToDo.vue?2551bfb4